<div class="fpp-claim-finish">
  <app-hero-banner heroTitle="Thanks! We’ve received your claim!"
                   heroImage="assets/consumer-mobile/happy-finish.svg"
                   messageTitle="What’s Next?"
                   messageBody="Our team will review your claim and reach out to you if needed. Please check your app notifications or email."></app-hero-banner>
  <ng-container *cdkPortal>
    <button type="button" mat-flat-button (click)="closeDialog()">Dashboard</button>
  </ng-container>
</div>
